import { defineComponent, ref } from 'vue'

export default defineComponent(
  (props) => {
    const icon = ref('')
    console.log('propspropspropsprops', props)

    watchEffect(async () => {
      try {
        console.log('propspropspropsprops', props)
        const iconsImport = import.meta.glob('assets/icons/**/**.svg', {
          as: 'raw',
          eager: false,
        })
        const rawIcon = await iconsImport[`/assets/icons/${props.name}.svg`]()
        console.log(rawIcon)
        icon.value = rawIcon
      } catch {
        console.error(`[nuxt-icons] Icon '${props.name}' doesn't exist in 'assets/icons'`)
      }
    })

    return () => h('span', { style: { display: ' flex' }, innerHTML: icon.value })
  },
  {
    props: {
      name: {
        type: String,
        default: '',
      },
    },
  },
)
